import { render, staticRenderFns } from "./overview-general-page.vue?vue&type=template&id=6fd2bf20&scoped=true&"
import script from "./overview-general-page.vue?vue&type=script&lang=js&"
export * from "./overview-general-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd2bf20",
  null
  
)

export default component.exports